import { Component, inject } from '@angular/core';
import { AutocompleteComponent } from '@shared/components/autocomplete';
import {
  DynamicPhoneValidationDirective,
  PhoneNumberMaskDirective,
} from '@shared/directives';
import { ButtonComponent } from '@shared/components/button';
import { RegisterGuardianshipFormService } from './register-guardianship-form.service';
import { ReactiveFormsModule } from '@angular/forms';
import { UserSearchStateService } from '../../shared/services/user-search-state.service';
import {
  HandleAutocompleteOptionClickDirective,
  HandleUserSearchDirective,
} from '../../shared/directives';
import { FormMessageComponent } from '@shared/components/forms';
import { getPhonePrefixOptions } from '@shared/utils';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { DYNAMIC_PHONE_DIRECTIVE_CONFIG } from '../../shared/constants/dynamic-phone-directive-config.constants';
import { CloseApplicationModalDirective } from '../../shared/directives/close-modal.directive';
import { InputFileComponent } from '@shared/components/input-file/input-file.component';
import { ACCEPTED_FILE_TYPES } from './accepted-file-types.constant';
import { HandleClerkCreateGuardianshipSubmitDirective } from './directives/handle-clerk-create-guardianship-submit.directive';
import { ClerkCreateGuardianshipFacadeService } from './clerk-create-guardianship-facade.service';
import { CcsInputComponent, CcsSelectComponent } from '@shared/components';
import { CREATE_APPLICATION_GUARDIANSHIP_ERROR_MESSAGES } from './constants';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-clerk-create-guardianship-form',
  templateUrl: 'clerk-create-guardianship-form.component.html',
  imports: [
    AutocompleteComponent,
    DynamicPhoneValidationDirective,
    ButtonComponent,
    ReactiveFormsModule,
    HandleUserSearchDirective,
    HandleAutocompleteOptionClickDirective,
    FormMessageComponent,
    DynamicPhoneValidationDirective,
    CloseApplicationModalDirective,
    InputFileComponent,
    HandleClerkCreateGuardianshipSubmitDirective,
    PhoneNumberMaskDirective,
    CcsSelectComponent,
    CcsInputComponent,
    MatSlideToggleModule,
  ],
  providers: [
    RegisterGuardianshipFormService,
    ClerkCreateGuardianshipFacadeService,
  ],
})
export class ClerkCreateGuardianshipFormComponent {
  private readonly _formService = inject(RegisterGuardianshipFormService);

  protected readonly form = this._formService.form;

  private readonly _userSearchStateService = inject(UserSearchStateService);

  protected readonly isLoading = this._userSearchStateService.isLoading;

  protected readonly phonePrefixOptions = getPhonePrefixOptions();
  protected readonly ERROR_MESSAGES =
    CREATE_APPLICATION_GUARDIANSHIP_ERROR_MESSAGES;

  protected formattedUsersByName =
    this._userSearchStateService.formattedSearchedUsersByName;
  protected formattedUsersByEmail =
    this._userSearchStateService.formattedSearchedUsersByEmail;

  protected get isPhonePrefixUS() {
    return this.form.controls.prefixPhone.value === DEFAULT_USA_PHONE_PREFIX;
  }

  protected readonly dynamicPhoneDirectiveConfig =
    DYNAMIC_PHONE_DIRECTIVE_CONFIG;

  protected readonly acceptedFileTypes = ACCEPTED_FILE_TYPES;

  protected readonly isFirm = this._formService.isFirm;
}
